import { memo } from "react";
import { useTranslate } from "helpers";
import { classNames } from "helpers";
import { ReactSVG } from "react-svg";
import { FLEET_VEHICLE_STATUS_CONFIG } from "services/api/fleet/vehicles/consts";
import { FleetVehicleStatusBadgeProps } from "../types";


const VehicleStatusBadge: React.FC<FleetVehicleStatusBadgeProps> = ({
  status,
  onClick,
  showDropdownIcon = true,
}) => {
  const { t } = useTranslate();

  const config = FLEET_VEHICLE_STATUS_CONFIG[status];

  if (!config) return null;

  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        "inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-xs font-medium cursor-pointer transition-all hover:opacity-80",
        config.color
      )}
    >
      <span className={classNames("w-2 h-2 rounded-full", config.dotColor)} />
      <span>{t(config.label)}</span>
      {showDropdownIcon && (
        <ReactSVG
          src="/media/icons/chevron-down.svg"
          className={classNames("w-[14px] h-[14px] ml-0.5 transition ease-in-out delay-150", config.strokeColor)}
        />
      )}
    </button>
  );
};

export default memo(VehicleStatusBadge);
